/**
 * Converts a string into a URL-safe type string.
 * Replaces Finnish letters ä, ö, å with a/o equivalents
 * and replaces spaces with underscores.
 * 
 * Example:
 * "Järjestelmäkuvaukset ja riskiluokitus" => "jarjestelmakuvaukset_ja_riskiluokitus"
 */
export function normalizeType(str) {
  if (!str) return "";
  return str
    .toLowerCase()
    .replace(/ä/g, "a")
    .replace(/ö/g, "o")
    .replace(/å/g, "a")
    .replace(/\s+/g, "_") // spaces → underscores
    .replace(/[^a-z0-9_-]/g, ""); // remove any other non-URL-safe characters
}
